import * as React from "react";
import { PT_ProtectiveFunction } from "../models/PT_ProtectiveFunction";
import { SS_PT_SupportSystemSheet } from "../models/SS_PT_SupportSystemSheet";
import Modal from "react-bootstrap/Modal";
import { DeviceData } from "../models/DeviceData";
import { SilModal } from "./SilModal";
import { DiagramApiController } from "../models/DiagramApiController.generated";
import { DiagramData } from "../models/DiagramData";
import { SS_SupportSystemSheet } from "../models/SS_SupportSystemSheet";
import { MasterPoolMismatchItem } from "../models/MasterPoolMismatchItem";



interface Props {
  supportSystem?: DeviceData;
  closeModal: () => void;
  supportSystemSheet?: SS_PT_SupportSystemSheet; // Bound device sheet, contains device instance data
  setDiagramData?: (diagramData: DiagramData) => void;
  deviceSheet?: SS_SupportSystemSheet; // Template device sheet
  onDeviceSheetRestoreClick?: (
    ptProtectiveFunctionId: number
  ) => Promise<void>;
  masterPoolMismatchItems?: MasterPoolMismatchItem[];
  readOnly: boolean;
}

interface State {
  supportSystem?: PT_ProtectiveFunction;
  closeFocus: boolean;
  isDeviceSheetMatch: boolean;
}

export class SupportModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    if (this.props.supportSystem != null) {
      this.state = {
        supportSystem: { ...this.props.supportSystem.ptProtectiveFunction },
        closeFocus: false,
        isDeviceSheetMatch: true
      }
    } else {
      this.state = {
        closeFocus: false,
        isDeviceSheetMatch: true
      };
    }
    this.handleRestoreDeviceSheet = this.handleRestoreDeviceSheet.bind(this);
  }

  save() {
    if (this.props.readOnly) { return; }

    return DiagramApiController.updateSupportSystem(this.state.supportSystem).then(dd => {
      this.props.setDiagramData(dd);
      this.props.closeModal();
    });
  }

  handleChange = (e: React.ChangeEvent<any>) => {
    const supportSystem = { ...this.state.supportSystem };
    supportSystem[e.target.name] = e.target.value;
    this.setState({ supportSystem });
  }

  componentDidMount() {
    if (this.props.masterPoolMismatchItems && this.props.masterPoolMismatchItems.find(x => x.protectiveFunctionId == this.props.supportSystem.ptProtectiveFunction.protectiveFunctionID)) {
      this.setState({ isDeviceSheetMatch: false })
    }
  }

  private handleRestoreDeviceSheet() {
    const device = { ...this.props.supportSystem };
    this.props.onDeviceSheetRestoreClick(device.ptProtectiveFunction.protectiveFunctionID).then(() => this.props.closeModal());
  }

  render() {
    const device = this.state.supportSystem;
    const supportSystemSheet = this.props.supportSystemSheet;
    const deviceSheet = this.props.deviceSheet;

    const isBoundDevice = this.props.supportSystem != null && this.props.supportSystemSheet != null;
    const deviceId = isBoundDevice ? device.deviceId : deviceSheet.supportSystemID;
    const supportSystemType = isBoundDevice ? device.supportSystemType : deviceSheet.supportSystemType;
    const tagName = isBoundDevice ? device.tageName : "";
    const proofTestingInterval = isBoundDevice ? device.proofTestingInterval.toString() : "";
    const pfdAvg = isBoundDevice ? device.nonCcfPfdAverage.display : deviceSheet.pfdAverageDisplay;
    const str = isBoundDevice ? supportSystemSheet.xstR1Year : "";
    const note = isBoundDevice ? supportSystemSheet.supportSystemDescription : deviceSheet.supportSystemDescription;
    const dataSource = isBoundDevice ? device.source : deviceSheet.source;
    const hft = isBoundDevice ? supportSystemSheet.hft : deviceSheet.hft;

    return (
      <SilModal closeModal={this.props.closeModal} title="Support System" width={635}>
        <table>
          <tbody>
            <tr>
              <td>
                <div className='support-row'>
                  <div className='support-label'>
                    <label htmlFor="txt_tblsupportid" style={{ fontWeight: 1000 }}>Support System ID:</label>
                  </div>
                  <div className='support-text-area'>
                    <input name="txt_tblsupportid" defaultValue={deviceId} type="text" readOnly id="txt_tblsupportid" style={{ borderStyle: 'None', borderBottom: '1px solid #000', width: '100%' }} />
                  </div>
                </div>
                <div className='support-row'>
                  <div className='support-label'>
                    <label htmlFor="txt_tblsupporttype" style={{ fontWeight: 1000 }}>Support System Type:</label>
                  </div>
                  <div className='support-text-area'>
                    <textarea name="txt_tblsupporttype" defaultValue={supportSystemType} rows={2} cols={20} readOnly id="txt_tblsupporttype" style={{ borderStyle: 'None', height: '60px', width: '100%', borderBottom: '1px solid #000' }} />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <table style={{ background: '#90b0f4', width: '600px', height: '30px' }}>
                  <tbody><tr>
                    <td>
                      <label htmlFor="txt_tblsupporttag" style={{ fontSize: 'small', fontWeight: 200 }}>Support System Tag:</label>
                    </td>
                    <td style={{ paddingLeft: '100px' }}>
                      <input name="tageName"
                        value={tagName}
                        type="text"
                        id="txt_tblsupporttag"
                        style={{ height: '20px', width: '100px' }}
                        onChange={(e) => this.handleChange(e)}/>
                    </td>
                  </tr>
                    <tr>
                      <td>
                        <label htmlFor="supportSystemTestIntervalTextBox"
                          style={{ fontSize: 'small', fontWeight: 200 }}>
                          Proof Testing Interval (yr):
                        </label>
                      </td>
                      <td style={{ paddingLeft: '100px' }}>
                        <input 
                          name="proofTestingInterval"
                          value={proofTestingInterval}
                          type="text"
                          id="supportSystemTestIntervalTextBox"
                          onChange={(e) => this.handleChange(e)}
                          style={{ height: '20px', width: '100px' }} />
                      </td>
                    </tr>
                  </tbody></table>
              </td>
            </tr>
            <tr>
              <td style={{ paddingTop: '10px' }}>
                <table style={{ background: '#6b932a', borderRadius: '10px', MozBorderRadius: '10px', WebkitBorderRadius: '10px', width: '600px', height: '40px' }}>
                  <tbody><tr>
                    <td style={{ paddingLeft: '10px' }}>
                      <label htmlFor="txt_tblsupportpfdavg" style={{ fontSize: 'small', fontWeight: 'bold' }}>PFDavg:</label>
                    </td>
                    <td style={{ paddingLeft: '10px' }}>
                      <input name="txt_tblsupportpfdavg" defaultValue={pfdAvg} readOnly type="text" id="txt_tblsupportpfdavg" style={{ borderStyle: 'None', borderBottom: '1px solid #000', backgroundColor: '#6b932a' }} />
                    </td>
                    <td style={{ paddingLeft: '10px' }}>
                      <label htmlFor="txt_tblsupportstr" style={{ fontSize: 'small', fontWeight: 'bold' }}>STR:</label>
                    </td>
                    <td style={{ paddingLeft: '10px' }}>
                      <input name="txt_tblsupportstr" defaultValue={str} readOnly type="text" id="txt_tblsupportstr" style={{ borderStyle: 'None', borderBottom: '1px solid #000', backgroundColor: '#6b932a' }} />
                    </td>
                  </tr>
                  </tbody></table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody><tr>
                    <td style={{ paddingTop: '10px' }}>
                      <label htmlFor="txt_tblsupportnote" style={{ fontSize: 'medium', fontWeight: 'bold' }}>Note:</label>
                    </td>
                  </tr>
                    <tr>
                      <td>
                        <textarea name="txt_tblsupportnote" defaultValue={note} rows={2} cols={20} id="txt_tblsupportnote" style={{ height: '150px', width: '600px' }} />
                      </td>
                    </tr>
                  </tbody></table>
              </td>
            </tr>
            <tr>
              <td>
                <table style={{ width: '600px' }}>
                  <tbody><tr>
                    <td>
                      <label htmlFor="txt_tblsupportdatasource" style={{ fontWeight: 1000 }}>Data Source:</label>
                    </td>
                    <td style={{ paddingLeft: '10px' }}>
                      <input name="txt_tblsupportdatasource" defaultValue={dataSource} type="text" readOnly id="txt_tblsupportdatasource" style={{ borderStyle: 'None', borderBottom: '1px solid #000', width: '100px' }} />
                    </td>
                    <td>
                      <label htmlFor="lbl_hft" style={{ fontWeight: 1000 }}>HFT:</label>
                    </td>
                    <td style={{ paddingLeft: '10px' }}>
                      <input name="txt_hft" defaultValue={hft.toString()} type="text" readOnly id="txt_hft" style={{ borderStyle: 'None', borderBottom: '1px solid #000', width: '100px' }} />
                    </td>
                    <td style={{ paddingLeft: '50px', paddingTop: '10px', float: 'right', textAlign: 'right' }}>
                      {isBoundDevice
                        ? (
                          <input
                            type="submit"
                            name="Update_tblsupport"
                            className="edit-button"
                            value="Update"
                            id="Update_tblsupport"
                            onClick={() => this.save()}
                            disabled={this.props.readOnly}
                          />
                        ): null
                      }
                      {!this.state.isDeviceSheetMatch && (
                        <input
                          className="edit-button"
                          disabled={this.props.readOnly}
                          type="submit"
                          name="Restore_devicesheet_tbldevice"
                          value="Upgrade device sheet"
                          id="Restore_devicesheet_tbldevice"
                          onClick={this.handleRestoreDeviceSheet}
                        />
                      )}
                    </td>
                  </tr>
                  </tbody></table>
              </td>
            </tr>
          </tbody></table>
      </SilModal>
    );
  }
}